<template>
  <div>
    <PageAllow controller="Examines" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRange
              type="datetime"
              v-model="datetimeRage"
              :label="$t('Examine.Fields.created_time')"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="$permission.permissionAllow('Examines', 'batchExamine')"
              small
              dark
              color="orange"
              class="ms-1 float-end"
              @click="batchExamineDialog = true"
            >
              <v-icon x-small class="pe-1">fa-align-justify</v-icon>
              {{ $t("Examine.actions.batchExamine") }}
            </v-btn>
            <v-btn
              v-if="
                $permission.permissionAllow('Examines', 'batchDetailExport')
              "
              small
              color="print"
              dark
              class="ms-1"
              @click.stop="batchExportExcel()"
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("Export.batchExport") }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="order_code"
                  v-model="options.order_code"
                  @text="orderCodeKeyword = $event"
                  :label="$t('Examine.orderCodeKeyword')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="examine_code"
                  v-model="options.examine_code"
                  @text="examineCodeKeyword = $event"
                  :label="$t('Examine.examineCodeKeyword')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="shop_keyword"
                  v-model="options.keyword"
                  @text="shopKeyword = $event"
                  :label="$t('Examine.shopKeyword', [$consts.shopName()])"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherDistrictsWithDescendants v-model="districtSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStock v-model="stocksSelected" showVirtualStock />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherDistributionUser v-model="distributionUserSelected" />
              </v-col>
              <!-- 商品 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherMaterials v-model="options.material_ids" returnId />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.status"
                  :label="$t('Examine.status.title')"
                  :items="$consts.examine.status"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.abnormal_flgs"
                  :label="$t('Examine.abnormalFlgs.title')"
                  :items="$consts.examine.abnormal_flgs"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="examines"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          mobile-breakpoint="800"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.examine_code="{ item, index }">
            <span
              class="text-no-wrap caption font-weight-bold"
              :v-resize="!index ? $stickTableResizer() : null"
            >
            </span>
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.examine_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.created | formatTime }}
            </span>
          </template>
          <template v-slot:item.shop.shop_name="{ item }">
            <span class="text-no-wrap caption font-weight-bold">
              {{
                item.shop
                  ? item.shop.shop_name + "【" + item.shop.shop_code + "】"
                  : ""
              }}
            </span>
            <br />
            <a
              class="text-no-wrap caption"
              :href="'/#/orders/' + item.order_id"
              style="text-decoration: none"
            >
              {{ item.order_code }}
            </a>
          </template>
          <template v-slot:item.distribution_user_name="{ item }">
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.distribution_user_name }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.stock ? item.stock.name : "" }}
            </span>
          </template>
          <template v-slot:item.examine_flg="{ item }">
            <span v-if="item.examine_flg == 0" class="danger--text">
              {{ item.examine_flg | examineFlgsText }}
            </span>
            <span v-else-if="item.examine_flg == 1">
              {{ item.shop_user_name }}
            </span>
            <span v-else>{{ item.examine_flg | examineFlgsText }}</span>
          </template>
          <template v-slot:item.is_examined="{ item }">
            {{ item.is_examined | examineStatusText }}
            <v-chip
              v-if="settings && settings.abnormal_examine"
              small
              label
              :color="item.abnormal_flg | examineIsAbnormaledColor"
              :text-color="item.abnormal_flg | examineIsAbnormaledTextColor"
              >{{ item.abnormal_flg | examineIsAbnormaledText }}
            </v-chip>
            <v-chip
              v-else
              small
              label
              :color="item.examine_abnormal | examineAbnormalFlgsColor"
              :text-color="item.examine_abnormal | examineAbnormalFlgsTextColor"
              >{{ item.examine_abnormal | examineAbnormalFlgsText }}
            </v-chip>
          </template>
          <template v-slot:item.examine_time="{ item }">
            {{ item.examine_time | formatTime }}
          </template>
          <template v-slot:item.actions="{ item }">
            <ExamineActions
              :examine="item"
              showView
              showExport
              :showExamine="item.actions.examine"
              :showAbnormal="item.actions.abnormal"
              :showAbnormalDetail="item.actions.abnormal_detail"
              :showExamineImg="item.examine_img ? true : false"
            />
          </template>
        </v-data-table>
      </div>
    </v-sheet>

    <!-- 批量验收 -->
    <DialogAlert
      v-model="batchExamineDialog"
      :title="$t('$vuetify.warning')"
      :message="$t('Examine.Messages.batchExamineAlert')"
      persistent
      useConfirm
      @confirm="
        batchExamineDialog = false;
        batchExaminingInfoDialog = true;
        batchExamine(JSON.parse(JSON.stringify(options)));
      "
    />
    <BatchOperationInfoAlert
      v-model="batchExaminingInfoDialog"
      :title="$t('$vuetify.alert')"
      :message="batchExaminingInfo"
      persistent
      :closable="errorCount > 0"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherDistributionUser from "@/components/plugins/SearcherDistributionUser";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import ExamineActions from "./plugins/Actions";
import Examines from "@/api/examines";
import DialogAlert from "@/components/plugins/DialogAlert";
import BatchOperationInfoAlert from "./plugins/BatchOperationInfoAlert";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";

const defaultOptions = {
  created_time_from:
    new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  examine_code: "",
  order_code: "",
  keyword: "",
  stock_ids: [],
  distribution_user_ids: [],
  status: [0],
  abnormal_flgs: [0, 1],
  material_ids: [],
  no_children_district_codes: [],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRange,
    SearcherKeyword,
    SearcherStock,
    SearcherDistributionUser,
    SearcherStatus,
    ExamineActions,
    DialogAlert,
    BatchOperationInfoAlert,
    SearcherMaterials,
    SearcherDistrictsWithDescendants,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.orderManagement"),
        disabled: false,
        replace: true,
        href: "/orders",
      },
      {
        text: i18n.t("Nav.examines"),
        disabled: true,
        href: "/examines",
      },
    ],

    headers() {
      return [
        {
          text:
            i18n.t("Examine.Fields.examine_code") +
            " / " +
            i18n.t("Examine.Fields.created_time"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "examine_code",
        },
        {
          text:
            i18n.t("Examine.Fields.shop_name", [this.$consts.shopName()]) +
            " / " +
            i18n.t("Examine.Fields.order_code"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "shop.shop_name",
        },
        {
          text:
            i18n.t("Examine.Fields.distribute_line") +
            " / " +
            i18n.t("Examine.Fields.stock_name"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "distribution_user_name",
        },
        {
          text: i18n.t("Examine.Fields.examiner"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "examine_flg",
        },
        {
          text: i18n.t("Examine.Fields.examine_status"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "is_examined",
        },
        {
          text: i18n.t("Examine.Fields.examine_time"),
          align: "center",
          class: "text-no-wrap",
          width: "180",
          sortable: false,
          value: "examine_time",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "actions",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols"]),
  },

  data: () => ({
    datetimeRage: [
      new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
    examineCodeKeyword: "",
    orderCodeKeyword: "",
    shopKeyword: "",
    stocksSelected: null,
    distributionUserSelected: null,
    examines: [],
    options: JSON.parse(
      sessionStorage.getItem("examines-options")
        ? sessionStorage.getItem("examines-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    errorCount: 0,
    successCount: 0,
    error_order_id: [],
    batchExamineOrders: [],
    batchExamineOrderLength: 0,
    alreadyExaminedOrderLength: 0,
    batchExamineDialog: false,
    batchExaminingInfoDialog: false,
    batchExaminingInfo: i18n.t("Examine.Messages.batchExaminingInfo", [0, 0]),
    districtSelected: [],
  }),

  mounted() {
    this.$commonUtils
      .loadOptions("examines", [
        "stocksSelected",
        "distributionUserSelected",
        "districtSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            if (
              typeof this.options.created_time_from != "undefined" &&
              typeof this.options.created_time_to != "undefined"
            )
              this.datetimeRage = [
                this.options.created_time_from,
                this.options.created_time_to,
              ];
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stocksSelected":
                this.stocksSelected = selected.value;
                break;
              case "distributionUserSelected":
                this.distributionUserSelected = selected.value;
                break;
              case "districtSelected":
                this.districtSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        examine_code: this.examineCodeKeyword,
        order_code: this.orderCodeKeyword,
        keyword: this.shopKeyword,
      });
    },

    resetSearch() {
      this.stocksSelected = null;
      this.distributionUserSelected = null;
      this.districtSelected = [];
      this.datetimeRage = [
        new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date().toISOString().substr(0, 10) + " 23:59:59",
      ];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [
        this.$refs.examine_code,
        this.$refs.order_code,
        this.$refs.shop_keyword,
      ].forEach((k) => {
        if (k) k.clear();
      });
    },

    getExaminesFromAPI() {
      //整理异常状态搜索条件
      if (
        this.options.abnormal_flgs.find((flgs) => flgs == "1") &&
        this.options.abnormal_flgs.length <= 2
      ) {
        this.options.abnormal_flgs.push(2, 3);
      } else if (
        this.options.abnormal_flgs.find((flgs) => flgs == "2") &&
        !this.options.abnormal_flgs.find((flgs) => flgs == "1")
      ) {
        if (
          "0" in this.options.abnormal_flgs &&
          this.options.abnormal_flgs.length == 3
        ) {
          this.options.abnormal_flgs = [0];
        } else {
          this.options.abnormal_flgs = [];
        }
      }

      Examines.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.examines = response.data.examines;
            this.paging = response.data.paging;

            let batchExamineOrders = [];
            this.examines.forEach((examine) => {
              //取可出库的单子
              if (examine.actions.examine) {
                batchExamineOrders.push(examine);
              }
            });
            this.batchExamineOrders = batchExamineOrders;
            this.batchExamineOrderLength = batchExamineOrders.length;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },

    batchExamine(options) {
      // 记录回传失败的单子
      if (this.error_order_id.length) {
        options.no_examine_ids = this.error_order_id;
      }
      Examines.batchExamine(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.examine_flg) {
              ++this.successCount;
            } else {
              this.error_order_id.push(response.data.examine_id);
              ++this.errorCount;
            }
          } else {
            if (response.data.error.code != "ERR333") {
              this.error_order_id.push(response.data.examine_id);
              ++this.errorCount;
            } else {
              this.getExaminesFromAPI();
              options = null;
              this.error_order_id = [];
              this.successCount = 0;
              this.errorCount = 0;
              this.alreadyExaminedOrderLength = 0;
              this.batchExaminingInfoDialog = false;
              this.$store.commit("refreshToDos", true);
            }
          }
          //去除本次验收的单子
          this.batchExamineOrders.splice(0, 1);
          //实时计数
          this.batchExaminingInfo = i18n.t(
            "Examine.Messages.batchExaminingInfo",
            [this.successCount, this.errorCount]
          );
          ++this.alreadyExaminedOrderLength; //计已验收的单子总数
          if (
            response.data.status.isOK() ||
            response.data.error.code != "ERR333"
          ) {
            //回调
            this.batchExamine(options);
          }
        }.bind(this)
      );
    },
    batchExportExcel() {
      //整理异常状态搜索条件
      if (
        this.options.abnormal_flgs.find((flgs) => flgs == "1") &&
        this.options.abnormal_flgs.length <= 2
      ) {
        this.options.abnormal_flgs.push(2, 3);
      } else if (
        this.options.abnormal_flgs.find((flgs) => flgs == "2") &&
        !this.options.abnormal_flgs.find((flgs) => flgs == "1")
      ) {
        if (
          "0" in this.options.abnormal_flgs &&
          this.options.abnormal_flgs.length == 3
        ) {
          this.options.abnormal_flgs = [0];
        } else {
          this.options.abnormal_flgs = [];
        }
      }
      Examines.batchDetailExport(this.options);
    },
  },

  watch: {
    settings: {
      immediate: true,
      handler() {
        this.getExaminesFromAPI();
      },
    },
    options: {
      deep: true,
      handler() {
        this.getExaminesFromAPI();
        sessionStorage.setItem(
          "examines-options",
          JSON.stringify(this.options)
        );
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.created_time_from =
            new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.created_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.created_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.created_time_to = this.datetimeRage[1];
        }
      },
    },
    stocksSelected: {
      handler() {
        this.options.stock_ids = this.stocksSelected
          ? this.stocksSelected.id
          : "";
        sessionStorage.setItem(
          "examines-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
    distributionUserSelected: {
      handler() {
        this.options.distribution_user_id = this.distributionUserSelected
          ? this.distributionUserSelected.id
          : "";
        sessionStorage.setItem(
          "examines-distributionUserSelected",
          JSON.stringify(this.distributionUserSelected)
        );
      },
    },
    districtSelected: {
      handler() {
        this.options.no_children_district_codes = this.districtSelected
          ? this.districtSelected.map((e) => {
              return e.code;
            })
          : [];
        sessionStorage.setItem(
          "examines-districtSelected",
          JSON.stringify(this.districtSelected)
        );
      },
    },
  },
};
</script>